
import Cookies from './Cookies';

export default class PWForm {
    constructor(pw_form) {
        // const pw_form = document.querySelector('#th-pwForm');
        this.cookies = new Cookies();
        console.log(pw_form);
        if(pw_form) {
            if(this.cookies.getCookie('nsincorrectpw')){
                pw_form.querySelector('.js-incorrect').classList.remove('--is-hidden');
            }

            const submit = pw_form.querySelector('#pw-submit');
            submit.addEventListener('click', function(){
                var d = new Date();
                d.setTime(d.getTime() + 4000);
                var expires = "expires="+ d.toUTCString();
                document.cookie = "nsincorrectpw=1;" + expires + ";path=/";
            });

        }
    }
}
